// @flow

export function formatPrice(price: string | number): string {
  if (typeof price === "number") {
    return price.toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 4,
    });
  }
  return price;
}

export function formatPriceWithKOrM(price: number): string {
  if (price > 999999) {
    return formatPriceWithM(price);
  }

  return formatPriceWithK(price);
}

function formatPriceWithK(price: number): string {
  const formattedPrice = formatPrice(price);
  const regex = /(^.*)(,.*)$/gi;
  return formattedPrice.replace(regex, "$1K");
}

function formatPriceWithM(price: number): string {
  const formattedPriceInMillions = formatPrice(price / 1000000);
  return `${formattedPriceInMillions}M`;
}
